const path = location.pathname;

async function boot() {
  if (path === '/' || path === '/pasaporte-mensajero' || path === '/mi-pedido' || path === '/buzon-mensajero') {
    await import('./experience-home.js');
    return;
  }
  if (path.startsWith('/admin')) {
    const { default: noop, ...module } = await import('./admin11.js');
    return module;
  }
  if (path.startsWith('/operador')) {
    const { default: noop, ...module } = await import('./operator11.js');
    return module;
  }
  if (path.startsWith('/menu') || path.startsWith('/catalogo') || path.startsWith('/pedido/')) {
    const { default: noop, ...module } = await import('./catalog.js');
    return module;
  }
  await import('./customer.js');
}

await boot().catch(error => {
  console.error(error);
  const bootStatus = document.getElementById('boot-status');
  if (bootStatus) {
    bootStatus.hidden = false;
    bootStatus.innerHTML = `<div><strong>No se pudo iniciar la aplicación.</strong><span>${String(error?.message || error)}</span></div>`;
  }
});
